module.exports = __webpack_public_path__ + "assets/img/img25.b211ccaa.png";